// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { RawMessage } from "@lib/messaging/RawMessage";
import { Socket } from "@lib/messaging/Socket";
import { IEventListener } from "@lib/utilities/IEventListener";

/**
 * Defines an API for an endpoint that has only one socket connected to it and therefore does not require a socket ID to determine where to send a message.
 */
export type SingleSocketEndpoint = {
  readonly socketType: "single";
  readonly onMessage: IEventListener<(endpoint: SingleSocketEndpoint, socket: Socket, rawMessage: RawMessage) => void>;
  readonly socket: Socket;
  sendRawMessage(rawMessage: RawMessage): void;
};